// Server-client clock offset. Added to Date.now() by serverNow() so schedule
// arithmetic uses server time rather than the device clock.
let offset = 0;

export const initServerTimeOffset = serverTime => {
  if (typeof serverTime !== 'number' || Number.isNaN(serverTime)) return;
  offset = serverTime - Date.now();
};

export const serverNow = () => new Date(Date.now() + offset);

export const getServerTimeOffset = () => offset;
